import * as React from 'react';
export const IcCallNumber = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.62 15.86a2 2 0 00-2.83 0l-.7.71a1 1 0 01-1.42 0l-4.24-4.24a.999.999 0 010-1.42l.71-.7a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.83 0l-1 1a2 2 0 00-.56 1.13c-.16 1.4-.04 4.74 3.68 8.48s7.08 3.84 8.49 3.72a2 2 0 001.13-.56l1-1a2 2 0 000-2.83l-.72-.75zM21 6h-.31l.25-.65a1.002 1.002 0 10-1.88-.7L18.56 6h-1.87l.25-.65a1.002 1.002 0 10-1.88-.7L14.56 6H13a1 1 0 000 2h.81l-.75 2H12a1 1 0 000 2h.31l-.25.65a1.001 1.001 0 00.59 1.29A1 1 0 0013 14a1 1 0 00.94-.65l.5-1.35h1.87l-.25.65a1.001 1.001 0 00.59 1.29A1 1 0 0017 14a1 1 0 00.94-.65l.5-1.35H20a1 1 0 100-2h-.81l.75-2H21a1 1 0 100-2zm-3.94 4h-1.87l.75-2h1.87l-.75 2z'
      fill='currentColor'
    />
  </svg>
);
